// client/src/services/api.js
import axios from 'axios';

const API_BASE = 'https://apitestubcok.paragraf.spb.ru/api';

// Получение всех данных
export const getAllData = async () => {
    const response = await axios.get(`${API_BASE}/all-data`);
    return response.data;
};

// Получение статуса синхронизации
export const getSyncStatus = async () => {
    const response = await axios.get(`${API_BASE}/sync/status`);
    return response.data;
};

// Запуск синхронизации
export const runSync = async () => {
    const response = await axios.post(`${API_BASE}/sync/now`);
    return response.data;
};

// Получение деталей школы (использует локальные данные)
export const getSchoolDetails = async (id, startDate = '', endDate = '') => {
    // Для совместимости с существующим кодом
    // В новой архитектуре данные уже есть на клиенте
    const response = await axios.get(`${API_BASE}/school/${id}`, {
        params: { startDate, endDate }
    });
    return response.data;
};

// Получение топ школ
export const getTopSchools = async (district = 'all', startDate = '', endDate = '') => {
    const response = await axios.get(`${API_BASE}/schools/top`, {
        params: { district, startDate, endDate }
    });
    return response.data;
};

// Получение списка районов
export const getDistricts = async () => {
    const response = await axios.get(`${API_BASE}/districts`);
    return response.data;
};

// Получение диапазона дат
export const getDateRange = async () => {
    const response = await axios.get(`${API_BASE}/date-range`);
    return response.data;
};